export const POSTER_USER_SETTINGS = 'POSTER_USER_SETTINGS';

export const Settings = {
  DEMANDS_LIST_MODE: 'demands_list_mode',
  DEMANDS_SORTS: 'demands_sorts',
  BATCH_CREATION_CART_SORTS: 'batch_creation_cart_sorts',
};
